import React from "react";
import {useSitePricingQueryQuery} from "../../generated/graphql";
import {GraphQlSelect} from "./GraphQlSelect";
import { variableCurrencyValue } from "../field-table";
import { useDaybookContext } from "../../contexts/Daybook/DayBookContext";

export const SitePricingSelect = (props) => {
    const query = useSitePricingQueryQuery();
    const daybook = useDaybookContext();
    const renderOptionString = (item)=>{
        if(!item) return 'NONE';
        return(item.label+' '+variableCurrencyValue({currency:item.currency??daybook?.defaultSiteCurrency,value:item.panel,places:2} as any));
    }
    // eslint-disable-next-line react/prop-types, react/display-name
    return <GraphQlSelect queryResult={query} {...props}  renderOptionString={renderOptionString} labelField="label" />;
}

